import React from 'react';

import {
  Panel,
  PanelHeader,
  Tabs,
  TabsItem
} from '@vkontakte/vkui';

import { PredictionContent } from './components/PredictionContent';
import { MobilePredictionPanelProps } from './types';
import { HeaderContent } from '../../../../../components/HeaderContent';
import { StackedScreens } from '../../../../../components/StackedScreens';
import { AboutUsPage } from '../../../pages/AboutUsPage'; 
import { AfterUserChoosePage } from '../../../pages/AfterUserChoosePage';
import { UserEnteringPage } from '../../../pages/UserEnteringPage'; 
import './forTestMVkCom.css';

export const MobilePredictionPanel: React.FC<MobilePredictionPanelProps> = ({
  id,
  needShowHeaderBack,
  handleBack, 
  showed,
  handlePredictionTab,
  handleAboutTab,
  showedStacked,
  predictionContentRef,
}) => {
  const blockWidth = window.innerWidth;

  const render = () => {
    if (showed.index == 0){
      return (
        <div
          key="StackedScreens"
          style={{
            position: 'relative',
            display: 'flex',
            width: blockWidth,
            flexShrink: 0,
            height: '100%',
          }}>
          <StackedScreens
            showedData={showedStacked}
            width={blockWidth}
            screens={[
              <PredictionContent ref={predictionContentRef}/>,                 
              <UserEnteringPage/>,
              <AfterUserChoosePage/>
            ]}
            screenIds={['PredictionContent', 'FriendTemperament', 'AfterUserChoose']}
          />
        </div>
      );
    }
    else{
      return (
        <AboutUsPage/>
      );
    }
  };


  return (
    <Panel id={id} style={{ display: 'flex', height: '100%', width: '100%' }}>

      <PanelHeader
        fixed={false}
        separator={false}
        before={needShowHeaderBack ? 
          <HeaderContent
            needBackIcon
            title="Назад"
            onClick={handleBack}
          />
          :
          undefined} 
      />
      <Tabs>
        <TabsItem
          selected={showed.index === 0}
          onClick={handlePredictionTab}
        >
          Тест
        </TabsItem>
        <TabsItem
          selected={showed.index === 1}
          onClick={handleAboutTab}
        >
          О проекте
        </TabsItem>
      </Tabs>

      {render()}

    </Panel>
  );
};

